import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import EmployeeInitiatives from '../../components/employees/EmployeeInitiatives.jsx';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import EmployeeProfileHeaderContainer from './EmployeeProfileHeaderContainer.jsx';

import {
  searchEmployeeInitiatives,
  selectEmployee,
} from '../../modules/employees.js';

const mapStateToProps = (state, ownProps) => ({
  employee: selectEmployee(ownProps.employeeId)(state),
});

const mapDispatchToProps = {
  searchEmployeeInitiatives,
};

// Initiatives tab of the employee profile
const EmployeeProfileContainer = ({
  employeeId,
  search,
  employee,
  searchEmployeeInitiatives,
}) => {
  // GET employees/:id returns both the header data and the initiatives
  useEffect(() => {
    searchEmployeeInitiatives(employeeId, search);
  }, [employeeId, search]);

  return (
    <React.Fragment>
      <EmployeeProfileHeaderContainer
        employeeId={employeeId}
        fetchEmployee={false}
      />
      {employee && !employee.communicationParticipations ? (
        <Empty simplified content={loadingContent} />
      ) : null}
      {employee?.communicationParticipations ? (
        <EmployeeInitiatives employee={employee} />
      ) : null}
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeProfileContainer);
